module.exports = __webpack_public_path__ + "static/media/home-chat.991dbde6.png";